<script lang="ts">
    import { Col, Row } from "sveltestrap";
    import SearchPagination from "./SearchPagination.svelte";
    import data from "../../../Data/SearchResult/SearchResult.json"
    import Link from "svelte-link";
    import {searchResults} from "../../../store"
    import VideoRightSide from "./VideoRightSide.svelte";
    let setSearchResult:string
    searchResults.subscribe((value)=>{
        setSearchResult = value
    })
</script>
<div class="tab-pane fade {setSearchResult === "video-link" ? "show active" :""}" id="video-link" >
    <Row>
        <Col xl="6" class="xl-100 box-col-12">
            <p class="pb-4">{'About 6,000 results (0.60 seconds)'}</p>
            {#each data.videosdata as searchItem}
                <div class="media info-block">
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <iframe class="me-3 mb-3" width="200" height="100" src="https://www.youtube.com/embed/CJnfAXlBRTE"></iframe>
                    <div class="media-body">
                        <h6>{searchItem.header}</h6>
                        <Link href="">{searchItem.link}</Link>
                        <p>{searchItem.detail}</p>
                        <div class="star-ratings">
                            <ul class="search-info">
                                <li>{searchItem.info}</li>
                                <li>{searchItem.info2}</li>
                                <li>{searchItem.info3}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            {/each}
        </Col>
        <VideoRightSide />
        <SearchPagination />
    </Row>
</div>